import Landing from "./Landing";
import TutorialVideo from "./TutorialVideo";
import SelectBackground from "./SelectBackground";
import CropPhoto from "./CropPhoto/index";
import EditorSimple from "./EditorSimple";
import EditorTemplate from "./EditorTemplate";
import EditorText from "./EditorText";
import PreviewLabel from "./PreviewLabel/index";
import EditorFilter from "./EditorFilter/index";
import Terms from "./Legal/Terms";
import Privacy from "./Legal/Privacy";
import Accessibility from "./Legal/Accessibility";
import Error from "./Error";
import ProductSelector from "./ProductSelector/index";
import PrintLabel from "./PrintLabel/index";
import ThanksMessage from './ThanksMessage/ThanksMessage';

const Areas = {
  Landing,
  TutorialVideo,
  SelectBackground,
  CropPhoto,
  EditorSimple,
  EditorText,
  EditorTemplate,
  PreviewLabel,
  EditorFilter,
  Terms,
  Privacy,
  Accessibility,
  Error,
  ProductSelector,
  PrintLabel,
  ThanksMessage
};

export default Areas;



// WEBPACK FOOTER //
// ./src/components/areas/index.js